import { useEffect, useRef } from 'react';

export function TrackVisibility({ onVisible, children }) {
    const ref = useRef();

    useEffect(() => {
        if (!ref.current) return;

        const observer = new IntersectionObserver(
            ([entry], observerInstance) => {
                if (entry.isIntersecting) {
                    onVisible?.();
                    observerInstance.disconnect(); // fire only once
                }
            },
            { threshold: 0.1 } // Adjust if needed
        );

        observer.observe(ref.current);

        return () => observer.disconnect();
    }, []);

    return <div ref={ref}>{children}</div>;
}
